import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import toastConfig from '../config/Toast';
import useApi from '../api';
import useAnalytics from '../analytics/analytics';

const ExportQuestionsButton: React.FC = () => {
  const { getBlob } = useApi();
  const { captureEvent } = useAnalytics();
  const [isExporting, setIsExporting] = useState(false);

  const exportToCSV = async () => {
    try {
      setIsExporting(true);
      const response = await getBlob('/questions/export');
      const blob = response.blob;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `questions-export-${new Date().toISOString()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Questions exported successfully', toastConfig);
      captureEvent('export_questions', {});
    } catch (error) {
      console.error('Error exporting questions:', error);
      toast.error('Failed to export questions', toastConfig);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      variant="outline"
      onClick={exportToCSV}
      className="whitespace-nowrap"
      disabled={isExporting}
    >
      {isExporting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Download />}
      {isExporting ? 'Exporting…' : 'Export to CSV'}
    </Button>
  );
};

export default ExportQuestionsButton;

